import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const FormControlStyles = css(
    ({ theme }) => css`
        .FormControl {
            row-gap: ${theme.spacing[2]};

            .FormControlLabelRoot .Label {
                ${getTypographyStyle("body2Strong")}
                color: ${theme.palette.text};
            }

            .FormControlHint {
                margin-left: 0;
                ${getTypographyStyle("body4Strong")}
            }
        }
    `,
);
